import Axios from "axios";
import { SETTINGS } from "../properties/ApiProps";

export const VerificationRepository = {
  veirifyContract: (verificationCode, reCaptchaToken) => {
    return Axios({
      url: SETTINGS.API_URL + "api/verification/contract/" + verificationCode,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: reCaptchaToken,
    });
  },
};
